import Icon from '../components/Icon.vue'

Icon.register({"thumbs-down":{"width":512,"height":512,"paths":[{"d":"M0 56V296C0 309.3 10.7 320 24 320H104C117.3 320 128 309.3 128 296V56C128 42.7 117.3 32 104 32H24C10.7 32 0 42.7 0 56zM40 256C40 242.7 50.7 232 64 232S88 242.7 88 256 77.3 280 64 280 40 269.3 40 256zM312 512C291.8 512 282.5 472.7 278.1 454.2 272.9 432.5 267.5 410.1 252.7 395.3 220.2 362.8 203.2 321.3 163.6 282.2A12-12 0 0 0 160 273.7V59.9C160 53.4 165.2 48 171.8 47.9 187.6 47.6 208.5 38.8 224.4 31.7 256.2 17.6 295.7 0 344 0H346.8C389.6 0 440.2 0.4 460.6 29.7 469 41.8 471.1 56.8 466.8 74.4 483.1 91.4 491.8 123.2 483.1 149.1 500.7 172.6 502.3 205.3 492.5 228.6L492.6 228.7C504.5 240.7 512.1 260 512 277.9 511.8 308.3 485.8 336 452.4 336H350.7C358 364.3 384 388.1 384 430.5 384 504 336 512 312 512z"}]}})



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-awesome/icons/thumbs-down.js
// module id = null
// module chunks = 